import { FooterContent } from "custom-types/Directus";

import { AllActions } from "./rootReducer";

export type CmsState = {
  footer: {
    newsletter: {
      header: string;
      subCopy: string;
    };
  };
};

export const initialState: CmsState = {
  footer: {
    newsletter: {
      header: "Stay In Touch",
      subCopy:
        "Receive updates on new products, special offers, and industry news.",
    },
  },
};

export const LOAD_FOOTER_CONTENT = "cms/footer/load";

export type LoadFooterContentAction = {
  type: typeof LOAD_FOOTER_CONTENT;
  countryCode: string;
  footerContent?: FooterContent | null;
};

export type CmsActions = LoadFooterContentAction;

const cmsReducer = (state = initialState, action: AllActions): CmsState => {
  switch (action.type) {
    case LOAD_FOOTER_CONTENT:
      if (action.footerContent) {
        const isCa = action.countryCode === "CA";
        return {
          ...state,
          footer: {
            newsletter: {
              header: action.footerContent.email_signup_section_header,
              subCopy: isCa
                ? action.footerContent.email_signup_section_ca_sub_copy
                : action.footerContent.email_signup_section_sub_copy,
            },
          },
        };
      } else {
        return state;
      }
    default:
      return state;
  }
};

export default cmsReducer;
